export default __webpack_public_path__ + "static/05-8adfa8ba45fbef53470da1ed8e069795.gif";